

export const JOYRIDE_CONSTANT = {
  homepage: 'homepage-joyride',
  profilepage: 'profilepage-joyride',
}
